import equal from "fast-deep-equal/es6/react";

const IsNotEqual = (objA: object, objB: object) => {
    var result = !equal(objA, objB);
    return result;
};

export const AreEqual = (objA: object, objB: object) => !IsNotEqual(objA, objB);

export default IsNotEqual;
